import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

import Home from "./pages/Home";
import LoanTypes from "./pages/LoanTypes";
import CreditChallenges from "./pages/CreditChallenges";
import ApplyToBuy from "./pages/ApplyToBuy";
import AboutMe from "./pages/AboutMe";
import Sellers from "./pages/Sellers";
import NewToTexas from "./pages/NewToTexas";
import Admin from "./pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/loan-types" element={<LoanTypes />} />
            <Route path="/credit-challenges" element={<CreditChallenges />} />
            <Route path="/apply-to-buy" element={<ApplyToBuy />} />
            <Route path="/about-me" element={<AboutMe />} />
            <Route path="/sellers" element={<Sellers />} />
            <Route path="/new-to-texas" element={<NewToTexas />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
